<template>
    <div>
        <div class="add-economic-record-title1 ml-2 mt-1">Cargar Lote</div>
        <div class="d-flex justify-content-center mt-1 headTitle mb-2">{{fincaName}}</div>
        <div class="d-flex flex-column justify-content-center px-1">
            <validation-observer>
                <b-form>
                    <b-form-group label="Nombre" class="mt-2" label-for="name">
                        <validation-provider #default="{ errors }" name="name" rules="required">
                            <b-form-input id="name" v-model="lots.name" :state="errors.length > 0 ? false : null"
                                name="name" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                    <div>Seleccionar Animales</div>
                    

                        <!-- table -->
                    <vue-good-table :columns="columns" :rows="rows" :rtl="direction" 
                    :search-options="{
                        enabled: false,
                        externalQuery: searchTerm
                    }" 
                    
                    :pagination-options="{
                        enabled: true,
                        perPage: pageLength
                    }"
                    :select-options="{
                        enabled: true,
                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                        selectionInfoClass: 'custom-class',
                        selectionText: 'rows selected',
                        clearSelectionText: 'clear',
                        disableSelectInfo: true, // disable the select info panel on top
                        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
                    }"

              @on-selected-rows-change="selectedAnimal"
                    >
                    <template slot="table-row" slot-scope="props">

                        <!-- Column: Name -->
                        <span v-if="props.column.field === 'sex'" class="text-center">
                        <span v-if="props.row.sex===false" class="text-center">M</span>
                        <span v-if="props.row.sex===true" class="text-center">H</span>
                        
                        </span>

                        <!-- Column: Status -->
                        <span v-else-if="props.column.field === 'status'">
                        <b-badge :variant="statusVariant(props.row.status)">
                            {{ props.row.status }}
                        </b-badge>
                        </span>

                        <!-- Column: Common -->
                        <span v-else>
                        {{ props.formattedRow[props.column.field] }}
                        </span>
                    </template>

                    <!-- pagination -->
                    <template slot="pagination-bottom" slot-scope="props">
                        <div class="d-flex justify-content-between flex-wrap">
                        <div class="d-flex align-items-center mb-0 mt-1">
                            <span class="text-nowrap ">
                            Mostrando 1 de
                            </span>
                            <b-form-select v-model="pageLength" :options="['25', '50', '100']" class="mx-1"
                            @input="(value) => props.perPageChanged({ currentPerPage: value })" />
                            <span class="text-nowrap"> of {{ props.total }} registros </span>
                        </div>
                        </div>
                    </template>
                    </vue-good-table>

                        <div class="d-flex align-items-center justify-content-center">
                            <div class="">Cantidad de Animales</div>
                                <b-form-group label="" label-for="numberAnimal" class="ml-1 w-25">
                                    <validation-provider #default="{ errors }" name="numberAnimal" rules="required">
                                        <b-form-input id="numberAnimal"  v-model="numberAnimal" :state="errors.length > 0 ? false : null"
                                            name="numberAnimal" />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                         </div>
                  
                    <div class="d-flex justify-content-center ">
                        <b-button  class="bg-primary w-75" v-on:click="insertLots">
                            <div class="d-flex justify-content-center ">
                                <div class="ml-2">Incluir Lote </div>
                                <div style="color:#D7B92C">
                                    <feather-icon icon="PlusIcon" size="18" class="ml-2" />
                                </div>
                            </div>
                        </b-button>
                    </div>
                </b-form>
            </validation-observer>
        </div>
        <ControlMenu />
    </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'
import "vue-select/dist/vue-select.css";
import { VueGoodTable } from 'vue-good-table';
import { BRow, BCol, BLink, BImg, BFormGroup, BForm, BButton, BFormSelect, BFormInput, BFormCheckbox, BFormTextarea } from 'bootstrap-vue'
import ControlMenu from '@/components/ControlMenu.vue'
import { required } from '@validations'
import axios from 'axios'
//let apiURL='https://927d1d30.us-south.apigw.appdomain.cloud/ganapp/api/';
let self= this;
export default {
    components: {
    BFormGroup,
    vSelect,
    VueGoodTable,
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    required,
    BLink,
    BImg,
    BForm,
    BButton,
    BFormSelect,
    BFormInput,
    ControlMenu,
    BFormCheckbox,
    BFormTextarea,
    ControlMenu
},
    data() {
        return {
            status: '',
            selected: '',
            numberAnimal:null,
            name: '',
            animalBox:null,
            fincaName:localStorage.getItem('currentFarmName'),
            animalsList:[],
            otherDetail:'',
            batchOptions:[],
            weight: null,
            ageOptions: ['1', '2', '3'],
            items: [],
            pageLength: 25,
            columns: [
                {
                    label: 'CODIGO',
                    field: 'number',
                },  
                {
                    label: 'ANIMAL',
                    field: 'name',
                },
                {
                    label: 'SEXO',
                    field: 'sex',
                },
                {
                    label: 'PESO',
                    field: 'weight',
                },
                {
                    label: 'EDAD',
                    field: 'age',
                },
            ],
            rows:[],
            lots:{
                number:'',
                name:'',
                farm_id:localStorage.getItem('currentFarm'),
            }

        }
    },
    methods:{
        async fetchAnimals(config) {
            let farmId= localStorage.getItem('currentFarm');
            fetch(this.$apiUrl+"list/animals?farm_id="+farmId+"&state=1", config)
            .then(response => response.json())
            .then(result => {
                console.log(result.animals);
                this.rows = result.animals.map(item => {return {id:item.id,number:item.number,name:item.name,sex:item.sex,weight:item.weight, age:item.age}});
                console.log(this.rows);
            })
        },

        selectedAnimal(params){
            this.items=params.selectedRows.map(item=>{return {id:item.id}});
            this.numberAnimal= this.items.length;
            console.log(this.items);
        },

        async insertLots(){
            const token = localStorage.getItem("accessToken");
            const config = {headers: {"X-Authorization": `Bearer ${token}`}};
            let lotId=0;
            this.$http.post("add/lots", this.lots,config)
            .then(result => {
                console.log(result);
                lotId=result.data.lots.id;
                this.lots={
                    number:'',
                    name:'',
                    farm_id:localStorage.getItem('currentFarm'),
                }

                var request= this.items.map(item =>this.$http.post("edit/animals/"+item.id ,{id:item.id, lot:lotId}, config));
                console.log(request);
                axios.all(request)
                .then(()=>{
                    this.$swal({
                        title: 'Registro de lote',
                        text: 'Se insertaron los registros de lote de manera satisfactoria',
                        type: 'success',
                        icon:'success',
                        showCancelButton: false,
                        confirmButtonColor:'#5E8F23',
                        showCloseButton: true,
                        showLoaderOnConfirm: false  
                    }).then(function(){
                        history.back();
                    });
                });
            
            }).catch(error => {
                console.log(error)
            });
            
            /*  */
        }
    },
    created() {
      const token = localStorage.getItem("accessToken");
      const config = {headers: {"X-Authorization": `Bearer ${token}`}};
      this.fetchAnimals(config);
    }

}
</script>

<style lang="scss">
table{
    width: 100% !important;
  }
  .headTitle {
  font-weight: 600;
  font-size: 24px;
  color: #5E8F23;
}
@import '@core/scss/vue/pages/page-auth.scss';
</style>
